import "./resource-details.css";
